<template>
    <div class="TicketLoadFormModal">
        <TicketLoadForm ref="ticketLoadForm" v-bind.sync="formLoad" :previousLoad="previousLoad"/>
        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleSubmit">{{ isEditMode ? 'Update' : 'Add' }}</Button>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import TicketLoadForm from './TicketLoadForm'

export default {
    name: 'TicketLoadFormModal',

    components: { TicketLoadForm },

    props: {
        load: { type: Object, required: true },
        previousLoad: { type: Object, default: null },
        onSubmit: { type: Function, default: () => {} },
        isEditMode: { type: Boolean, default: false },
    },

    data: () => ({
        formLoad: null,
    }),

    beforeMount() {
        this.formLoad = cloneDeep(this.load);
    },

    methods: {
        handleSubmit() {
            if (!this.$refs.ticketLoadForm.validate()) {
                return;
            }

            this.$emit('close');
            this.onSubmit(this.formLoad);
        },

        handleCancel() {
            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.TicketLoadFormModal {
    @extend %modal;

    .actions {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
